import React from 'react';
import styled from 'styled-components';

export default function ImageUpload(props) {
  const { onChange, className } = props;
  return (
    <>
      <EditButton className={className} htmlFor='image-input'>
        Upload new
      </EditButton>
      <HiddenInput id='image-input' type='file' onChange={onChange} />
    </>
  );
}

const EditButton = styled.label`
  color: #4597e0;
  font-size: 13px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const HiddenInput = styled.input`
  display: none;
`;
